const DNI_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKET'

function dni (rule, value, callback) {
  if (value) {
    const dniReg = /^\d+[a-zA-Z]$/
    const nifReg = /^[klmxyzKLMXYZ]\d{7}[a-zA-Z]$/
    if (dniReg.test(value)) {
      const number = value.substr(0, value.length - 1)
      const letter = value.substr(value.length - 1, 1).toUpperCase()
      const result = number % 23
      if (letter !== DNI_LETTERS[result]) {
        callback(new Error('DNI erróneo'))
      } else {
        callback()
      }
    } else if (nifReg.test(value)) {
      const number = value.substr(1, value.length - 2)
      const letter = value.substr(value.length - 1, 1).toUpperCase()
      const result = number % 23
      if (letter !== DNI_LETTERS[result]) {
        callback(new Error('NIE erróneo'))
      } else {
        callback()
      }
    } else {
      callback(new Error('Formato inválido'))
    }
  } else {
    callback(new Error('Campo obligatorio'))
  }
}

export {
  dni
}
